var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-share"},[_c('van-share-sheet',{attrs:{"title":"立即分享给好友","options":_vm.options},on:{"select":_vm.onSelect},model:{value:(_vm.showShare),callback:function ($$v) {_vm.showShare=$$v},expression:"showShare"}}),_c('van-icon',{attrs:{"name":"share-o"},on:{"click":function($event){_vm.showShare = true}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }